import { render, staticRenderFns } from "./read-more.vue?vue&type=template&id=83443968&"
import script from "./read-more.vue?vue&type=script&lang=ts&"
export * from "./read-more.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83443968')) {
      api.createRecord('83443968', component.options)
    } else {
      api.reload('83443968', component.options)
    }
    module.hot.accept("./read-more.vue?vue&type=template&id=83443968&", function () {
      api.rerender('83443968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/read-more.vue"
export default component.exports